import axios from 'axios'
import auth from '../users/auth'
import logoutOnUnauthorized from "../logout";

const ENDPOINT = auth.api.endpointPath
const ENDPOINT_USERS = auth.api.endpointPath + 'users'
const ENDPOINT_CHANGE_PASSWORD = ENDPOINT + 'password_change_requests'
const userList = {}

export default {
  getUsers () {
    const token = sessionStorage.getItem('token')
    axios.defaults.headers.common.Authorization = 'Bearer ' + token
    return axios.get(ENDPOINT_USERS).catch(logoutOnUnauthorized)
  },
  getAssignedPills() {
    const token = sessionStorage.getItem('token')
    const id = sessionStorage.getItem('user_id')
    axios.defaults.headers.common.Authorization = 'Bearer ' + token
    return axios.get(ENDPOINT_USERS + '/' + id + '/pillpack_plays').catch(logoutOnUnauthorized)
  },
  getSelfUser () {
    const token = sessionStorage.getItem('token')
    const id = sessionStorage.getItem('user_id')
    axios.defaults.headers.common.Authorization = 'Bearer ' + token
    return axios.get(ENDPOINT_USERS + '/' + id).catch(() => auth.logout())
  },
  getUserById (id) {
    if (userList !== null) {
      return this.userList.find((user) => user.id === id)
    } else {
      const token = sessionStorage.getItem('token')
      axios.defaults.headers.common.Authorization = 'Bearer ' + token
      axios.get(ENDPOINT_USERS)
        .then(response => {
          this.userList = response.data['hydra:member']
          return response.data['hydra:member'].find((user) => user.id === id)
        })
        .catch(logoutOnUnauthorized)
    }
  },
  putUser (user) {
    const token = sessionStorage.getItem('token')
    axios.defaults.headers.common.Authorization = 'Bearer ' + token
    return axios.put(ENDPOINT_USERS + '/' + user.id, user).catch(logoutOnUnauthorized)
  },
  putAssignedPill (assignedPill) {
    const token = sessionStorage.getItem('token')
    axios.defaults.headers.common.Authorization = 'Bearer ' + token
    return axios.put(auth.api.endpointPath + 'assigned_pills/' + assignedPill.id, assignedPill).catch(logoutOnUnauthorized)
  },
  changePassword (data) {
    const token = sessionStorage.getItem('token')
    axios.defaults.headers.common.Authorization = 'Bearer ' + token
    return axios.post(ENDPOINT_CHANGE_PASSWORD, data).catch(logoutOnUnauthorized)
  },
  uploadImage (file) {
    const token = sessionStorage.getItem('token')
    axios.defaults.headers.common.Authorization = 'Bearer ' + token

    return axios.post(ENDPOINT + 'o/change-image', file).catch(logoutOnUnauthorized)
  }
}
